__webpack_require__.p = "/assets/turbo/9beac0d4/quellede/_next/";